import { UserContact } from '../../../models/user-contact';

/**
 * Criteria of the in-chat message filter (WEBCLIENT.CHATROOM.ENABLE_MESSAGE_FILTER).
 * Both date bounds are inclusive epoch seconds, null when not set.
 */
export interface MessageFilterCriteria {
  users: UserContact[];
  // start of the selected local day
  dateFrom: number;
  // end of the selected local day (23:59:59.999)
  dateTo: number;
}

export function createEmptyMessageFilterCriteria(): MessageFilterCriteria {
  return {
    users: [],
    dateFrom: null,
    dateTo: null
  };
}

export function checkIfMessageFilterHasDateRange(criteria: MessageFilterCriteria): boolean {
  return !!criteria && (criteria.dateFrom != null || criteria.dateTo != null);
}

/**
 * Number of active criteria (sender, date range), used for the filter button label.
 */
export function countActiveMessageFilterCriteria(criteria: MessageFilterCriteria): number {
  if (!criteria) {
    return 0;
  }
  let count = 0;
  if (criteria.users && criteria.users.length) {
    count++;
  }
  if (checkIfMessageFilterHasDateRange(criteria)) {
    count++;
  }
  return count;
}
